
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M8 2.75a.75.75 0 00-.75.75v17c0 .414.336.75.75.75h8a.75.75 0 00.75-.75v-17a.75.75 0 00-.75-.75H8zm.75 17V4.25h6.5v15.5h-6.5zm9.15-14.5a.75.75 0 00-.75.75v2a.75.75 0 001.336.469l1.6-2A.75.75 0 0019.5 5.25h-1.6zM17.15 11a.75.75 0 01.75-.75h1.6a.75.75 0 01.586 1.219l-1.6 2A.75.75 0 0117.15 13v-2zm.75 4.25a.75.75 0 00-.75.75v2a.75.75 0 001.336.468l1.6-2a.75.75 0 00-.586-1.218h-1.6zM6.85 6a.75.75 0 00-.75-.75H4.5a.75.75 0 00-.586 1.219l1.6 2A.75.75 0 006.85 8V6zm-.75 4.25a.75.75 0 01.75.75v2a.75.75 0 01-1.336.469l-1.6-2A.75.75 0 014.5 10.25h1.6zM6.85 16a.75.75 0 00-.75-.75H4.5a.75.75 0 00-.586 1.218l1.6 2A.75.75 0 006.85 18v-2zM12 8.75a1.75 1.75 0 100-3.5 1.75 1.75 0 000 3.5zM13.75 12a1.75 1.75 0 11-3.5 0 1.75 1.75 0 013.5 0zM12 18.75a1.75 1.75 0 100-3.5 1.75 1.75 0 000 3.5z"}})])
          )
        }
      }
    